import React from 'react';
import PropTypes from 'prop-types';

SendgridMessageDeliveryStatus.propTypes = {
  message: PropTypes.object.isRequired
};

export default function SendgridMessageDeliveryStatus(props) {
  // SendGrid event endpoint has been disabled on the API; always show 'No delivery information' delivery status
  // and avoid issuing any API calls.
  // Keep the component signature intact to avoid changing callers.
  const { message } = props; // eslint-disable-line no-unused-vars
  return 'No delivery information';
};
